// extracted by mini-css-extract-plugin
export default {"container":"NavigationLayout_container__TKxtc"};